export const IFRAME_SENDER = "ams_sdk";
